module.exports = __webpack_public_path__ + "images/emoji/baggage_claim.09e9e18740b7c94e0819.png";